


















import { Prop, Vue } from "vue-property-decorator";
import Component from "vue-class-component";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Pagination options form
 */
@Component({
  filters: {
    ...capitalizeFilter
  }
})
export default class PaginationOptionsForm extends Vue {
  @Prop() private setPageSize!: (pageSize: number) => void;

  pageSize = 20;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.invokePageSizeSetter();
  }

  pageSizeUpdated(event: InputEvent): void {
    if ((event.target as HTMLElement).tagName.toLowerCase() !== "input") {
      return;
    }
    this.invokePageSizeSetter();
  }

  private invokePageSizeSetter(): void {
    this.setPageSize(this.pageSize);
  }
}
